/**
 * Firestore 1日の読み取り予算を管理するガード。
 *
 * Firebase Spark（無料）プランの上限は 50,000 reads/日。
 * 安全ラインとして 80%（40,000）を予算上限とし、超えたら新規読み取りをブロックする。
 * 予算カウンターは日本時間の日付変更時に自動リセットされる。
 */

const DAILY_BUDGET = 40_000; // 50,000 の 80%
const WARN_THRESHOLD = 0.7;  // 70% で警告ログ

class FirestoreQuotaGuard {
  private readCount = 0;
  private resetDate = new Date().toDateString();

  /** 日付が変わっていたらカウンターをリセット */
  private checkReset(): void {
    const today = new Date().toDateString();
    if (today !== this.resetDate) {
      console.log(
        `[QuotaGuard] New day detected. Resetting counter (was ${this.readCount}).`
      );
      this.readCount = 0;
      this.resetDate = today;
    }
  }

  /** 読み取り可能かどうかを返す */
  canRead(): boolean {
    this.checkReset();
    return this.readCount < DAILY_BUDGET;
  }

  /** クエリが返したドキュメント数を記録する */
  recordReads(count: number): void {
    this.checkReset();
    this.readCount += count;

    const pct = this.readCount / DAILY_BUDGET;
    if (pct >= 1.0) {
      console.error(
        `[QuotaGuard] ⛔ DAILY BUDGET EXCEEDED: ${this.readCount}/${DAILY_BUDGET}`
      );
    } else if (pct >= WARN_THRESHOLD) {
      console.warn(
        `[QuotaGuard] ⚠️ ${Math.round(pct * 100)}% of daily budget used: ${this.readCount}/${DAILY_BUDGET}`
      );
    }
  }

  /** 現在の使用量を返す */
  getUsage(): { used: number; budget: number; percentage: number } {
    this.checkReset();
    return {
      used: this.readCount,
      budget: DAILY_BUDGET,
      percentage: Math.round((this.readCount / DAILY_BUDGET) * 100),
    };
  }
}

export const quotaGuard = new FirestoreQuotaGuard();
